import { createReducer, on } from '@ngrx/store';
import { PredictiveSearchState } from '../../models/states/predictive-search-state.interfaces';
import * as fromBookWidgetActions from '../actions/book-widget.actions';
import * as fromPredictiveSearchActions from '../actions/predictive-search.actions';

export const PredictiveSearchStateKey = 'predictiveSearch';

const initialState: PredictiveSearchState = {
  searchText: '',
  predictiveSearchResponse: null,
  isError: false
};

export const predictiveSearchReducer = createReducer(
  initialState,
  on(
    fromPredictiveSearchActions.LoadPredictiveSearchApiSuccess,
    (state, { predictiveSearchResponse }) => ({
      ...state,
      predictiveSearchResponse: predictiveSearchResponse,
      isError: false
    })
  ),
  on(fromPredictiveSearchActions.LoadPredictiveSearchApiFailure, (state) => ({
    ...state,
    predictiveSearchResponse: null,
    isError: true
  })),
  on(
    fromBookWidgetActions.InitPredictiveSearch,
    (state, { predictiveSearchString }) => ({
      ...state,
      searchText: predictiveSearchString
    })
  ),
  on(fromPredictiveSearchActions.LoadPredictiveSearchApi, (state) => ({
    ...state,
    predictiveSearchResponse: null,
    isError: false
  }))
);
